import storeInfo from 'ducks/store'
import { PropertyContact } from 'ducks/types'

export const getPropertyContacts = () => (): PropertyContact[] => {
  const { propertyContacts } = storeInfo.store.getState()
  return propertyContacts
}
